import { render, staticRenderFns } from "./six.vue?vue&type=template&id=142c48a9&scoped=true&"
var script = {}
import style0 from "./six.vue?vue&type=style&index=0&id=142c48a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142c48a9",
  null
  
)

export default component.exports